import React from 'react';

interface DateRangePickerProps {
  dateFrom: string;
  dateTo: string;
  onChangeFrom: (value: string) => void;
  onChangeTo: (value: string) => void;
  error?: string;
}

const today = () => new Date().toISOString().slice(0, 10);

function DateRangePicker({
  dateFrom,
  dateTo,
  onChangeFrom,
  onChangeTo,
  error,
}: DateRangePickerProps) {
  return (
    <div className="pq-field">
      <label className="pq-label">
        Date Range <span className="pq-required">*</span>
      </label>
      <div className="pq-date-range">
        <div className="pq-date-input-wrapper">
          <label className="pq-date-sublabel">From</label>
          <input
            type="date"
            className={`pq-date-input ${error ? 'has-error' : ''}`}
            value={dateFrom}
            max={today()}
            onChange={(e) => onChangeFrom(e.target.value)}
          />
        </div>
        <span className="pq-date-separator">&mdash;</span>
        <div className="pq-date-input-wrapper">
          <label className="pq-date-sublabel">To</label>
          <input
            type="date"
            className={`pq-date-input ${error ? 'has-error' : ''}`}
            value={dateTo}
            max={today()}
            onChange={(e) => onChangeTo(e.target.value)}
          />
        </div>
      </div>
      {error && <span className="pq-error pq-error--animate">{error}</span>}
    </div>
  );
}

export default DateRangePicker;
